import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { coverTypePlanPost } from "../../store/coverTypePlan/actions";
export var useCoverTypePlanPost = function (trigger, bodyRequest) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        responsePostCoverTypePlan: state.CoverTypePlan.responsePostCoverTypePlan,
        errorPostCoverTypePlan: state.CoverTypePlan.errorPostCoverTypePlan,
        loadingPostCoverTypePlan: state.CoverTypePlan.loadingPostCoverTypePlan,
    }); }), responsePostCoverTypePlan = _a.responsePostCoverTypePlan, errorPostCoverTypePlan = _a.errorPostCoverTypePlan, loadingPostCoverTypePlan = _a.loadingPostCoverTypePlan;
    useEffect(function () {
        if (trigger) {
            dispatch(coverTypePlanPost(bodyRequest));
        }
    }, [bodyRequest, trigger]);
    return {
        responsePostCoverTypePlan: responsePostCoverTypePlan,
        errorPostCoverTypePlan: errorPostCoverTypePlan,
        loadingPostCoverTypePlan: loadingPostCoverTypePlan,
    };
};
